import { usePlaybackRange, usePlaybackState } from '@app/core/playback/hooks/usePlayback';
import { useEffect } from 'react';

/**
 * Loads the first audio segment into the engine without starting playback.
 * Uses `MediaPlayer.preload` when available so logger and other players that
 * do not implement it are unchanged. Skips when this waveform is nested in a
 * parent player whose range does not match (e.g. logger).
 */
export function useRangeWaveformPreload(from: number) {
  const player = usePlaybackState((s) => s.player);
  const range = usePlaybackRange();

  useEffect(() => {
    if (!player || range?.from !== from) {
      return;
    }

    void player.preload?.(from);
  }, [player, from, range?.from]);
}
